//import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserContextProvider } from "./context/UserContext";
import PanelAdministrador from './views/PanelAdministrador'
import Principal from './views/Principal'
import Empresas from './views/Empresas'
import Empresasform from './views/Empresas/empresasform'
import Hoteles from './views/Hoteles'
import Hotelesform from './views/Hoteles/hotelesform'
import Habitaciones from './views/Habitaciones'
import Habitacionesform from './views/Habitaciones/habitacionesform'
import Productosform from './views/Productos/productosform'
import Productos from './views/Productos'
import Usuarios from './views/Usuarios'
import Usuariosform from './views/Usuarios/usuariosform'
import Inventarioform from './views/Inventario/inventarioform'
import Login from './views/Login'
import Inventario from './views/Inventario'
import Permisos from './views/Permisos'
import NoPage from './views/NoPage'
import GenerarHabitaciones from './views/GenerarHabitaciones';
import ProductosDefecto from './views/productosDefecto'
import Posteos from './views/Posteos'
import Roles from './views/Roles'
import Rolesform from './views/Roles/rolesform'
import Informes from './views/Informes'
import ResumenVentas from './views/Informes/resumenventas'
import Tipos from './views/Tipos'
import Tiposform from './views/Tipos/tiposform'
import Facturas from './views/Facturas'
import Facturasform from './views/Facturas/facturasform'
import Albaranes from './views/Albaranes'
import Albaranesform from './views/Albaranes/albaranesform'
import Caducidades from './views/Caducidades'
import Caducidadesform from './views/Caducidades/caducidadesform'
import ConceptosFacturas from './views/ConceptosFacturas'
import ConceptosFacturasform from './views/ConceptosFacturas/conceptosfacturasform'
import Factura1 from './views/PrevisualizaFacturas/factura1'
import Factura2 from './views/PrevisualizaFacturas/factura2'
import Factura3 from './views/PrevisualizaFacturas/factura3'

function App() {
  return (
    <UserContextProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Principal />}>
          <Route index element={<Posteos />} />
          <Route path="empresas" element={<Empresas />} />
          <Route path='empresasform/:accion/:id?' element={<Empresasform />} />
          <Route path="hoteles" element={<Hoteles />} />
          <Route path="hotelesform/:accion/:id?" element={<Hotelesform />} />
          <Route path="habitaciones" element={<Habitaciones />} />
          <Route path="habitacionesform/:accion/:id?" element={<Habitacionesform />} />
          <Route path="productos" element={<Productos />} />
          <Route path="productosform/:accion/:id?" element={<Productosform />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="usuariosform/:accion/:id?" element={<Usuariosform />} />
          <Route path="Permisos" element={<Permisos />} />
          <Route path="Login" element={<Login />} />
          <Route path="Inventario" element={<Inventario />} />
          <Route path="inventarioform/:accion/:id?" element={<Inventarioform />} />
          <Route path="generarhabitaciones" element={<GenerarHabitaciones />} />
          <Route path="productosDefecto" element={<ProductosDefecto />} />
          <Route path="posteos" element={<Posteos />} />
          <Route path="Roles" element={<Roles />} />
          <Route path="rolesform/:accion/:id?" element={<Rolesform />} />
          <Route path="Informes" element={<Informes />} />
          <Route path="resumenventas" element={<ResumenVentas />} />
          <Route path="tipos" element={<Tipos />} />
          <Route path="tiposform/:accion/:id?" element={<Tiposform />} />
          <Route path="facturas" element={<Facturas />} />
          <Route path="facturasform/:accion/:id?" element={<Facturasform />} />
          <Route path="albaranes" element={<Albaranes />} />
          <Route path="albaranesform/:accion/:id?" element={<Albaranesform />} />
          <Route path="caducidades" element={<Caducidades />} />
          <Route path="caducidadesform/:accion/:id?" element={<Caducidadesform />} />
          <Route path="conceptosfacturas" element={<ConceptosFacturas />} />
          <Route path="Factura1/:id?" element={<Factura1 />} />
          <Route path="Factura2/:id?" element={<Factura2 />} />
          <Route path="Factura3/:id?" element={<Factura3 />} />
          <Route path="conceptosfacturasform/:accion/:id?" element={<ConceptosFacturasform />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;
